import { Component, OnInit, inject, signal, computed } from '@angular/core';
import { AuthService, Block, BlockAbstractComponent, PageService, ParserService } from '@gallaghercp/core-frontend';
import { BreakpointObserver } from '@angular/cdk/layout';
import { WistiaScriptInjectionService } from '@core-app/services/wistia-script-injection.service';
import { ClientService } from '@core-app/services/client.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'core-block-wistia-video',
    templateUrl: './block-wistia-video.component.html',
    standalone: false,
})
export class BlockWistiaVideoComponent extends BlockAbstractComponent implements OnInit {
    protected override parser: ParserService;
    protected override pages: PageService;
    protected override auth: AuthService;
    protected breakpoint = inject(BreakpointObserver);
    private WistiaScriptInjectionService = inject(WistiaScriptInjectionService);
    private client = inject(ClientService);
    pillars$!: Observable<any>;

    activeFilter = signal<string>('all');
    limit = signal<number>(3);

    constructor() {
        const parser = inject(ParserService);
        const pages = inject(PageService);
        const auth = inject(AuthService);

        super(parser, auth, pages);

        this.parser = parser;
        this.pages = pages;
        this.auth = auth;
    }

    override ngOnInit(): void {
        this.pillars$ = this.client.getPillars();
        this.setWistiaVideoId();
        super.ngOnInit();
    }

    setWistiaVideoId() {
        // First inject the Wistia library script
        this.WistiaScriptInjectionService.injectScript('https://fast.wistia.com/assets/external/E-v1.js');
        // Check if block.content exists and has items
        if (this.block.content && this.block.content.length > 0) {
            // Loop through each item in block.content
            for (const item of this.block.content as Block[]) {
                // Check if item has data and data.id
                if (item.data && item.data.id) {
                    // Inject script for each video ID
                    this.WistiaScriptInjectionService.injectScript(
                        'https://fast.wistia.com/embed/medias/' + item.data.id + '.jsonp',
                    );
                }
            }
        }
    }

    filterBy(tag: string) {
        this.activeFilter.set(tag);
        this.limit.set(3);
    }

    showAll() {
        this.limit.set(this.filteredItems().length);
    }

    filteredItems = computed(() => {
        if (this.activeFilter() === 'all') {
            return this.block.content;
        }
        return this.block.content.filter((item: any) => item.data?.tag === this.activeFilter());
    });

    displayedItems = computed(() => {
        return this.filteredItems().slice(0, this.limit());
    });
}
